import apolloClient from '../../apolloClient';
import monitoringMutations from '../mutations/monitoring';
import monitoringQueries from '../queries/monitoring';
import deviceRoundQueries from '../queries/deviceRound';

const context = {
  current: 'monitoring',
};

const getSituationById = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.GET_SITUATION_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const getSituationsByIds = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.GET_SITUATIONS_BY_IDS,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const getSituationsByIdsMinimal = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.GET_SITUATIONS_BY_IDS_MINIMAL,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

// No deduplication: every open of the history log modal must get its own
// request, even if an earlier one for the same situation is still in flight.
const getSituationLog = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.GET_SITUATION_LOG,
    fetchPolicy: 'no-cache',
    variables,
    context: { ...context, queryDeduplication: false },
  });

const getWorkspaceSituationsHeatmap = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.GET_WORKSPACE_SITUATIONS_HEATMAP,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const getDeviceHistoriesBySituationId = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.GET_DEVICE_HISTORIES_BY_SITUATION_ID,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const freeDeviceHistory = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.FREE_DEVICE_HISTORY,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const sendOpenNotification = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.OPEN_SITUATION,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const openSituationChat = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.OPEN_SITUATION_CHAT,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const openCallWindow = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.OPEN_CALL_WINDOW,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const openCctvCamera = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.OPEN_CCTV_CAMERA,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const checkCCTVChannelRound = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.CHECK_CCTV_CHANNEL_ROUND,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const commentSituation = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.COMMENT_SITUATION,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const processSituation = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.PROCESS_SITUATION,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const processSituations = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.PROCESS_SITUATIONS,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const updateMonitoringStatus = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.UPDATE_MONITORING_STATUS,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const checkHealth = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.CHECK_HEALTH_MONITORING,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const checkHealthMaps = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.CHECK_HEALTH_MAPS,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const startCallRecording = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.START_CALL_RECORDING,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const addCallChunk = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.ADD_CALL_CHUNK,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const finalizeCallRecording = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.FINALIZE_CALL_RECORDING,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const getCallRecordingChunkUrls = async (variables) =>
  apolloClient.query({
    query: monitoringQueries.GET_CALL_RECORDING_CHUNK_URLS,
    fetchPolicy: 'no-cache',
    variables,
    context: { current: 'api' },
  });

const getDeviceCCTVActiveChannels = async (variables) =>
  apolloClient.query({
    query: deviceRoundQueries.GET_DEVICE_CCTV_ACTIVE_CHANNELS,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const holdSituation = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.HOLD_SITUATION,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

const generateCallSummary = async (variables) =>
  apolloClient.mutate({
    mutation: monitoringMutations.GENERATE_CALL_SUMMARY,
    fetchPolicy: 'no-cache',
    variables,
    context,
  });

export default {
  getSituationById,
  getSituationsByIds,
  getSituationsByIdsMinimal,
  getSituationLog,
  getWorkspaceSituationsHeatmap,
  getDeviceHistoriesBySituationId,
  freeDeviceHistory,
  sendOpenNotification,
  commentSituation,
  openSituationChat,
  openCallWindow,
  openCctvCamera,
  processSituation,
  processSituations,
  updateMonitoringStatus,
  checkCCTVChannelRound,
  checkHealth,
  checkHealthMaps,
  startCallRecording,
  addCallChunk,
  finalizeCallRecording,
  getCallRecordingChunkUrls,
  getDeviceCCTVActiveChannels,
  holdSituation,
  generateCallSummary,
};
